/**
 * Pure helpers shared across the app UI group. No DOM access; safe to import
 * from anywhere including tests.
 */

/**
 * The icon name a `dees-icon` expects. An already-qualified name (`lucide:Check`,
 * and any other `set:name`) is passed through untouched; a bare name is read as
 * a Lucide name and qualified. Qualifying an already-qualified name would ask
 * for the icon `Lucide:Check`, which no set has.
 */
export const normalizeIconName = (iconName: string): string =>
  iconName.includes(':') ? iconName : `lucide:${iconName}`;
